import { CommonModule } from '@angular/common';
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    HostListener,
    Input,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserService } from 'app/core/services/user.service';
import { environment } from 'environments/environment';
import { AuthService } from 'app/core/auth/auth.service';
import iframeResize from '@iframe-resizer/parent';
import { ZoomLevelService } from 'app/core/services/zoom-level.service';
import { EventsService } from 'app/core/services/events.service';
import { AutoLogoutService } from 'app/core/services/auto-logout.service';
import { StaffPlanService } from '../../events/pages/staff-plan/staff-plan.service';

@UntilDestroy()
@Component({
    selector: 'app-old-system-iframe',
    templateUrl: './old-system-iframe.component.html',
    styleUrls: ['./old-system-iframe.component.scss'],
    imports: [MatProgressSpinnerModule, CommonModule],
})
export class OldSystemIframeComponent implements AfterViewInit, OnInit {
    iframeLoading: boolean = true;
    internalIframeLoading: boolean = false;
    @Input() src: string;
    @Input() link: string = '';
    @Input() key: string = '';
    iFrameSrc: SafeResourceUrl;

    @ViewChild('myIframe') public myIframe;

    private functionTriggered: boolean = false;
    private _hidden: boolean = true;
    @Input()
    set hidden(value: boolean) {
        this._hidden = value;

        if (!this._hidden && !this.functionTriggered) {
            this.loadIframe();
            this.functionTriggered = true;
        }
    }

    @Output() show: EventEmitter<boolean> = new EventEmitter<boolean>();

    smallZoom = false;

    // @HostListener('window:resize', ['$event'])
    // onResize(event) {
    //     this.zoomLevelService.changeZoom();
    //     this.setZoomLevel();
    // }

    get hidden(): boolean {
        return this._hidden;
    }

    constructor(
        private sanitizer: DomSanitizer,
        private route: ActivatedRoute,
        private userService: UserService,
        private _authService: AuthService,
        private _router: Router,
        public zoomLevelService: ZoomLevelService,
        private events: EventsService,
        private cdr: ChangeDetectorRef,
        private autoLogoutService: AutoLogoutService,
        private staffplanService: StaffPlanService,
    ) {}

    ngOnInit(): void {
        this.setZoomLevel();
        this.events.subscribe('cdr', () => {
            this.cdr.detectChanges();
        });
    }

    setZoomLevel() {
        if (
            this.src === 'event/Staff_plan' ||
            this.src === 'event_scheduling/Event_scheduling' ||
            this.src === 'event/Video_screen_overview'
        ) {
            this.smallZoom = true;
        } else {
            this.smallZoom = false;
        }
        this.cdr.detectChanges();
    }

    async ngAfterViewInit() {
        this.route.queryParams.pipe(untilDestroyed(this)).subscribe(data => {
            if (data.oldSystem) {
                setTimeout(() => {
                    // this.show.emit(true);
                }, 0);
            }
        });
    }

    async loadIframe() {
        let url: string;
        url = `navigator.php?page=pages/${this.src}.php&uid=${this.userService.user.uid}&screen=full`;
        if (this.link != '') {
            url += `&link=${this.link}`;
        }
        if (this.key != '') {
            url += `&key=${this.key}`;
        }

        this.iFrameSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
            environment.apiURL + url
        );
    }

    iFrameLoaded(myIframe) {
        iframeResize(
            {
                license: 'GPLv3',
                checkOrigin: false,
                // heightCalculationMethod: 'lowestElement',
                // widthCalculationMethod: 'scroll',
                // autoResize: true,
                // sizeWidth: true,
                // scrolling:'auto'
            },
            myIframe
        );
        this.injectJavaScript(myIframe);
        this.iframeLoading = false;
    }

    injectJavaScript(myIframe) {
        const iframe = myIframe;
        const iframeWindow = iframe.contentWindow;
        const iframeDocument = iframeWindow.document;

        iframe.contentWindow.onbeforeunload = () => {
            console.log('onbeforeunload');
            this.internalIframeLoading = true;
            this.cdr.detectChanges();
        };

        myIframe.addEventListener('unload', () => {
            console.log('unload');
            this.internalIframeLoading = true;
            this.cdr.detectChanges();
        });

        // Add an event listener to check for URL changes
        myIframe.addEventListener('load', () => {
            console.log('load');
            this.internalIframeLoading = false;
            this.cdr.detectChanges();

            const checkUrl = () => {
                if (
                    iframeWindow.location.href.includes(
                        'navigator.php?page=pages/common/Login.php'
                    )
                ) {
                    this.signOut();
                }
            };

            checkUrl();

            const observer = new MutationObserver(checkUrl);
            observer.observe(iframeDocument.body, {
                childList: true,
                subtree: true,
            });
        });

        // Add styles
        const style = iframeDocument.createElement('style');

        // adding the following class to style.textContent
        // will remove the right scrollbar of the iframe
        // .page-base-right {
        //     margin: 0;
        //     width: 100%;
        //     height: 100%;
        // }

        style.textContent = `
            .page-top, .page-base-left {
                display: none!important;
            }
            .tab_box {
                height: max-content !important;
            }
        `;
        iframeDocument.head.appendChild(style);
    }

    signOut(): void {
        this._authService.signOut().subscribe();
        this.autoLogoutService.clearTimer();
        this.staffplanService.resetFilter();
        this._router.navigate(['/sign-in']);
    }

    initializeIframeEventListener(): void {
        window.addEventListener('message', event => {
            if (event.data && event.data.eventType === 'logout') {
                this.signOut();
            } else if (event.data && event.data.eventType === 'loading') {
                this.internalIframeLoading = true;
            } else if (event.data && event.data.eventType === 'loaded') {
                this.internalIframeLoading = false;
            }
        });
    }
}
